import { CommercialListingConfig } from '@tenants/types';
import { LOCALE_LISTING_EXP_COMMERCIAL_PATHS } from 'types/locales';

export const listingConfig: CommercialListingConfig = {
  forSale: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.FORSALE,
  forLease: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.FORLEASE,
  fullAddress: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.FULLADDRESS,
  price: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PRICE,
  propertyType: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PROPERTYTYPE,
  yearBuilt: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.YEARBUILT,
  highlights: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.HIGHLIGHTS,
  propertyDetails: {
    title: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PROPERTYDETAILS_TITLE,
    status: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PROPERTYDETAILS_STATUS,
    salePrice: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PROPERTYDETAILS_SALEPRICE,
    yearBuilt: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PROPERTYDETAILS_YEARBUILT,
    propertyType: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PROPERTYDETAILS_PROPERTYTYPE,
    buildingSize: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PROPERTYDETAILS_BUILDINGSIZE,
    lotSize: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PROPERTYDETAILS_LOTSIZE,
    capRate: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PROPERTYDETAILS_CAPRATE,
    stories: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PROPERTYDETAILS_STORIES,
    buildingClass: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PROPERTYDETAILS_BUILDINGCLASS,
    occupancyPct: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PROPERTYDETAILS_OCCUPANCYPCT,
    zoningDescription: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PROPERTYDETAILS_ZONINGDESCRIPTION,
    daysOnMarket: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PROPERTYDETAILS_DAYSONMARKET,
  },
  propertyDescription: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.PROPERTYDESCRIPTION,
  locationDescription: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.LOCATIONDESCRIPTION,
  viewMore: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.VIEWMORE,
  viewLess: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.VIEWLESS,
  requestMoreInfo: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.REQUESTMOREINFO,
  shareToSocial: LOCALE_LISTING_EXP_COMMERCIAL_PATHS.SHARETOSOCIAL,
};